import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { QrCodeData } from '@cue/data';

@Pipe({
  name: 'canShowPois',
  standalone: true,
})
export class CanShowPoisPipe implements PipeTransform {
  translocoService = inject(TranslocoService);

  transform(qrCodeList: QrCodeData[]): boolean {
    if (qrCodeList) {
      return qrCodeList.filter((x) => !x.notNavigationPoint).length > 1;
    }
    return false;
  }
}
